import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';

interface SuccessDialogProps {
  open: boolean;
  onClose: () => void;
}

const SuccessDialog = ({ open, onClose }: SuccessDialogProps) => (
  <Dialog
    onClose={onClose}
    open={open}
    sx={{
      '& .MuiDialog-container': {
        alignItems: 'flex-start',
      },
    }}
    PaperProps={{
      sx: {
        width: '100%',
        maxWidth: '604px',
      },
    }}
  >
    <DialogTitle
      sx={{
        paddingX: '24px',
        paddingTop: '24px',
        paddingBottom: '16px',
      }}
    >
      <FormattedMessage defaultMessage='Report Submission Confirmation' />
    </DialogTitle>
    <DialogContent>
      <Typography color='#4F4F4F'>
        <FormattedMessage defaultMessage='Report has been generated and report has been closed.' />
      </Typography>
    </DialogContent>
    <DialogActions
      sx={{
        padding: '24px',
      }}
    >
      <Button
        variant='contained'
        color='blue'
        sx={{
          textTransform: 'none',
          height: '42px',
        }}
        disableElevation
        onClick={onClose}
      >
        <Typography fontSize={14} fontWeight={600}>
          <FormattedMessage defaultMessage='Close' />
        </Typography>
      </Button>
    </DialogActions>
  </Dialog>
);

export default SuccessDialog;
